module.exports = __webpack_public_path__ + "static/media/circle-linkedin.3c62538e.svg";